import { render, staticRenderFns } from "./importar.vue?vue&type=template&id=5381263c&scoped=true"
import script from "./importar.vue?vue&type=script&lang=js"
export * from "./importar.vue?vue&type=script&lang=js"
import style0 from "./importar.vue?vue&type=style&index=0&id=5381263c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5381263c",
  null
  
)

export default component.exports